<button
  type="button"
  class="button"
  (click)="onClick($event)"
  [disabled]="isDisabled"
  [ngClass]="{
    'button--search': config?.level && config?.level === ButtonLevels.search,
  }"
  tabindex="0"
  dataClickEvent
  (keydown.enter)="onClick($event)"
  [attr.aria-label]="config?.content"
  [attr.aria-description]="ariaDescription"
>
  <div class="button__content">
    @if (config?.icon && !config?.isIconRight) {
      <icon
        class="button__icon"
        [name]="config?.icon"
        [config]="{ fill: iconFill, size: config?.iconSize || 'small' }"
      >
      </icon>
    }

    @if (config?.content) {
      <span class="button__content--text" [innerHTML]="innerHtmlContent">
      </span>
    }

    @if (config?.icon && config?.isIconRight) {
      <icon
        class="button__icon"
        [name]="config?.icon"
        [config]="{ fill: iconFill, size: config?.iconSize || 'small' }"
      >
      </icon>
    }
  </div>
</button>
